<script setup lang="ts">
import Button from 'primevue/button';
import BaseIcon from '@/components/base/BaseIcon.vue';

withDefaults(defineProps<{
  loading?: boolean;
}>(), {
  loading: false,
});

const emit = defineEmits<{
  'request-new-report': [];
}>();
</script>

<template>
  <section class="xl:col-span-2 rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="flex items-start gap-3">
      <div class="w-11 h-11 rounded-lg bg-slate-100 text-slate-500 flex items-center justify-center shrink-0">
        <BaseIcon class="text-xl">description</BaseIcon>
      </div>
      <div class="min-w-0">
        <h2 class="text-2xl font-semibold text-slate-900 leading-tight">Sem Relatório para esta Política</h2>
        <p class="mt-2 text-slate-600 max-w-3xl">
          Esta política ainda não possui relatório KYX. Gere um novo relatório ou selecione outra política no painel à direita.
        </p>
        <div class="mt-4">
          <Button @click="emit('request-new-report')" label="Gerar Relatório" :loading="loading" />
        </div>
      </div>
    </div>
  </section>
</template>
